import Map from 'ol/Map';
import { type Projection } from 'ol/proj';
import { createContext, useContext } from 'react';

export type OpenLayersContextInterface = Readonly<{
  map: Map;
  mapProjection: Projection | string;
  userProjection: Projection | string;
}>;

const OpenLayersContext = createContext<OpenLayersContextInterface | undefined>(
  undefined
);

export const OpenLayersProvider = OpenLayersContext.Provider;

export function useOpenLayersContext(): OpenLayersContextInterface {
  const context = useContext(OpenLayersContext);
  if (context == null) {
    throw new Error(
      'No context provided: useOpenLayersContext() can only be used in a descendant of <MapContainer>'
    );
  }
  return context;
}
